import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("UI error boundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary-fallback"
          className="min-h-screen flex flex-col items-center justify-center bg-[#050505] text-white px-6 text-center"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-white/50 mb-6">
            Something went wrong
          </p>
          <h1 className="font-serif text-3xl sm:text-4xl tracking-tight mb-8">
            The page hit an unexpected error.
          </h1>
          <button
            data-testid="error-reload-button"
            onClick={() => window.location.reload()}
            className="border border-white/25 font-mono text-xs uppercase tracking-[0.15em] px-6 py-3 hover:bg-white hover:text-black transition-colors duration-300"
          >
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
